import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Modal from 'react-modal';
import { MultiRadio, ModalInfo } from 'shared/components';
import { isEmpty } from 'lodash';
import './TaskContent.scss';
import { convertKeywords } from 'shared/helpers';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
};

const radioList = [
  {
    key: 'default-1',
    label: 'Default',
    value: 'default',
  },
  {
    key: 'medium-1',
    label: 'Medium',
    value: 'medium',
  },
  {
    key: 'large-1',
    label: 'Large',
    value: 'large',
  },
];

const getLabel = (timerAction) => {
  switch (timerAction) {
    case 'start':
      return 'taskManagement.completeAndStartLabel';
    case 'stop':
      return 'taskManagement.completeAndStopLabel';
    default:
      return 'taskManagement.completeLabel';
  }
};

class TaskContent extends Component {
  constructor(props) {
    super(props);
    const fontSize = sessionStorage.getItem('fontSize');

    this.state = {
      enabledEditSize: false,
      sizeOptions: radioList,
      taskFontSize: fontSize,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onFontChange = this.onFontChange.bind(this);
    this.enableEdit = this.enableEdit.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderSubHeader = this.renderSubHeader.bind(this);
  }

  componentDidMount() {
    const fontSize = sessionStorage.getItem('fontSize');
    this.setState({
      taskFontSize: fontSize,
    });
  }

  onSubmit(task) {
    if (task.active) {
      this.props.submitTask(task);
    } else {
      this.props.toggleModal();
    }

    sessionStorage.removeItem('taskInProgress');
    if (this.state.warningModalOpen) {
      this.setState({
        warningModalOpen: false,
      });
      return;
    }
    this.setState({
      enabledEditSize: false,
    });
  }

  onFontChange(e) {
    const { value } = e.target;
    this.setState({
      taskFontSize: value,
    });
    sessionStorage.setItem('fontSize', value);
  }

  enableEdit() {
    this.setState({
      enabledEditSize: true,
    });
  }

  closeModal() {
    this.setState({
      enabledEditSize: false,
    });
    this.props.toggleModal();
  }

  renderSubHeader() {
    const { enabledEditSize, sizeOptions, taskFontSize } = this.state;

    return (
      <div className="size-section">
        {enabledEditSize ? (
          <div>
            <span className="text-strong">{this.props.t('common.labels.textSize')}</span>
            <span className="text-capitalize hide-xs">: {taskFontSize}</span>
            <div className="radio-container">
              <MultiRadio
                radioList={sizeOptions}
                checkedValue={taskFontSize}
                onChange={this.onFontChange}
              />
            </div>
          </div>
        ) : (
          <div>
            <span className="text-strong">{this.props.t('common.labels.textSize')}: </span>
            <span className="text-capitalize">{taskFontSize}</span>
            <button
              className="btn-link text-pacific-blue d-inline float-end"
              onClick={this.enableEdit}>
              {this.props.t('common.labels.change')}
            </button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { task, loadingCompleteTask } = this.props;
    const { taskFontSize } = this.state;

    let instructions = convertKeywords(task.instructions);

    const buttonLabel = task.active ? getLabel(task.timerAction) : 'common.labels.back';

    return (
      <div className="task-card" key={`task-${task.id}`}>
        <ModalInfo
          modalIsOpen={this.props.modalOpen}
          closeModal={this.closeModal}
          onSubmit={() => this.onSubmit(task)}
          headerTitle="taskManagement.taskTitle"
          saveLabel={buttonLabel}
          subHeaderContent={this.renderSubHeader()}
          className="task-modal"
          loadingButton={loadingCompleteTask}
          disableClose={loadingCompleteTask}>
          <div className="task-content">
            <div className="mt-3">
              <h4 className="mb-4">{task.name}</h4>
              <p
                className={`text-pre font-size-${taskFontSize}`}
                dangerouslySetInnerHTML={{ __html: instructions }}
              />
            </div>
          </div>
        </ModalInfo>
        <Modal
          isOpen={!isEmpty(this.props.alreadyCompletedMessage)}
          onRequestClose={this.props.removeCompleted}
          shouldCloseOnOverlayClick={false}
          style={customStyles}
          ariaHideApp={false}>
          <div className="text-center warning-container">
            <p>{this.props.alreadyCompletedMessage}</p>
            <button className="btn btn-warn text-center" onClick={this.props.removeCompleted}>
              {this.props.t('common.labels.ok')}
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(TaskContent);
TaskContent.propTypes = {
  task: PropTypes.shape({}).isRequired,
  removeCompleted: PropTypes.func.isRequired,
  submitTask: PropTypes.func,
  t: PropTypes.func.isRequired,
};
